import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranD04, EcranD04b, EcranX15 } from './conteneurs.js';

/** Écrans du lot L54 au registre de la coquille. D04, D04b et X15 lisent l'API ; l'exemple n'existe qu'en développement avec VITE_LAKOU_MOCKS=1. */
export const ecrans: Record<string, ComposantEcran> = {
  D04: EcranD04,
  D04b: EcranD04b,
  X15: EcranX15,
};
